import React from "react";
import "../styles/Legal.css";
import Footer from "../components/Footer";

const Privacy = () => {
  return (
    <>
      <div className="legal-container">
        <h1 className="legal-title">Privacy Policy</h1>
        <p className="legal-date">Effective Date: October 2025 • Last Updated: October 2025</p>

        <div className="legal-content">
          <p>
            <strong>
              CJet Dispatch (BN 8223233, Nigeria) & CJet Dispatch LLC (Entity ID 0008028488, New Mexico, USA)
            </strong>
            <br />
            Registered Offices:
            <br />• 2nd House Beside Mopo Barrack, Ilorin, Kwara State, Nigeria
            <br />• 70 Tripp Dr, Talladega, AL 35160, United States
            
            <br/>• Contact:{" "}
            <a href="mailto:support@cjetdispatch.com">support@cjetdispatch.com</a> 
            <br/>• Website:{" "}
            <a href="https://cjetdispatch.com" target="_blank" rel="noreferrer">
              https://cjetdispatch.com
            </a>
          </p>

          <h2>Legal Entity Information</h2>
          <p>
            (See the Legal Entity Information in the{" "}
            <a href="/terms" target="_blank" rel="noreferrer">
              Terms & Conditions
            </a>
            — the same entities apply to this Privacy Policy.)
          </p>

          <h2>1) Purpose</h2>
          <p>
            This Privacy Policy explains how CJet Dispatch (“CJet,” “we,” “our,” or “us”) collects, uses, shares, and
            protects personal data and shipment information when you use our Platform.
          </p>

          <h2>2) Information We Collect</h2>
          <ul>
            <li>
              <strong>Shipment Data:</strong> sender/recipient names, phone numbers, emails, and delivery addresses.
            </li>
            <li>
              <strong>Account Data:</strong> name, email, phone, login credentials.
            </li>
            <li>
              <strong>Payment Data:</strong> transaction references, billing addresses, payment confirmations (processed
              via secure third-party gateways; CJet does not store full card/PIN details).
            </li>
            <li>
              <strong>Operational Data:</strong> tracking numbers, shipment statuses, delivery confirmations.
            </li>
            <li>
              <strong>Technical Data:</strong> device identifiers, IP address, browser/OS details, logs.
            </li>
          </ul>

          <h2>3) How We Use Information</h2>
          <ul>
            <li>Process and manage dispatch requests.</li>
            <li>Generate and display tracking and shipment history.</li>
            <li>Communicate updates, receipts, and support responses.</li>
            <li>Detect and prevent fraud; comply with legal and regulatory duties.</li>
            <li>Improve service reliability, security, and user experience.</li>
          </ul>

          <h2>4) Sharing of Information</h2>
          <p>We do not sell personal data. We share data only as necessary with:</p>
          <ul>
            <li>
              <strong>Third-Party Providers:</strong> carriers, couriers, payment gateways, to fulfill dispatch and
              payment functions.
            </li>
            <li>
              <strong>Authorities:</strong> law enforcement or regulators where required by law.
            </li>
            <li>
              <strong>Technology Vendors:</strong> cloud hosting, analytics, or support providers under strict
              confidentiality and security terms.
            </li>
          </ul>

          <h2>5) Data Retention</h2>
          <ul>
            <li>
              We retain shipment and transaction data as long as needed for business, legal, accounting, or compliance
              purposes.
            </li>
            <li>Uploaded documents may be deleted automatically after successful processing.</li>
            <li>Tracking and payment history may be retained for audit and regulatory records.</li>
          </ul>

          <h2>6) Data Security</h2>
          <p>
            We use administrative, technical, and physical safeguards, including HTTPS/TLS encryption, access controls,
            and secure storage consistent with NDPR and applicable U.S. privacy standards.
          </p>

          <h2>7) Your Rights</h2>
          <p>Subject to law, you may:</p>
          <ul>
            <li>Request access to or correction of your personal data.</li>
            <li>Request deletion of your account/data (subject to statutory retention).</li>
            <li>Withdraw consent to marketing communications.</li>
          </ul>
          <p>
            Contact:{" "}
            <a href="mailto:support@cjetdispatch.com">support@cjetdispatch.com</a>
          </p>

          <h2>8) International Transfers</h2>
          <p>
            If data is stored or processed outside Nigeria (e.g., on U.S. or EU servers), we apply appropriate safeguards
            consistent with applicable data protection laws.
          </p>

          <h2>9) Fraud & Compliance</h2>
          <p>
            If fraud is suspected, we may share necessary data with banks, payment processors, carriers, or authorities
            to meet legal obligations.
          </p>

          <h2>10) Country-Specific Privacy Provisions</h2>
          <ul>
            <li>
              <strong>Nigeria (NDPR):</strong> Nigerian users have NDPR rights including access, rectification,
              portability, and erasure subject to lawful bases. Complaints may be directed to the Nigeria Data Protection
              Commission (NDPC).
            </li>
            <li>
              <strong>United States (CCPA/FTC):</strong> U.S. users have rights under CCPA (right to know/delete, subject
              to exceptions). We do not sell personal information. Complaints may be directed to the FTC or your state
              attorney general.
            </li>
          </ul>

          <h2>11) Updates</h2>
          <p>
            We may modify this Privacy Policy from time to time. Updated versions will be posted at{" "}
            <a href="https://cjetdispatch.com/privacy" target="_blank" rel="noreferrer">
              https://cjetdispatch.com/privacy-policy
            </a>
            . Continued use after updates constitutes acceptance.
          </p>

          <p>
            <strong>Data Controller Contact:</strong>{" "}
            <a href="mailto:support@cjetdispatch.com">support@cjetdispatch.com</a>
            <br />
            <strong>Postal:</strong> 2nd House Beside Mopo Barrack, Ilorin, Kwara State, Nigeria
          </p>

          <p className="legal-footer">© 2025 CJet Dispatch LLC. All rights reserved.</p>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Privacy;